import { useEffect, useRef } from 'react';

export function useInterval(callback: () => void, delay: number) {
  const savedCallback = useRef<() => void>();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      let id = setInterval(() => {
        if (typeof savedCallback.current === 'function') {
          savedCallback.current();
        }
      }, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}
